import { Component, inject } from '@angular/core';
import { Validators, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from 'environments/environment';
import { ReportsComponent } from '../../../shared/components/reports/reports.component';
import { NewReportOptionsTemplateDirective } from '../../../shared/directives/new-report-options-template.directive';
import { ReportClientOptionComponent } from '../../../shared/components/report-client-option/report-client-option.component';
import { IccReportClaimImportOptionComponent } from '../../components/icc-report-claim-import-option/icc-report-claim-import-option.component';
import { ReportBooleanOptionComponent } from '../../../shared/components/report-boolean-option/report-boolean-option.component';
import { ReportDetailsTemplateDirective } from '../../../shared/directives/report-details-template.directive';
import { ReportAppliedClientOptionComponent } from '../../../shared/components/report-applied-client-option/report-applied-client-option.component';
import { IccReportAppliedClaimImportOptionComponent } from '../../components/icc-report-applied-claim-import-option/icc-report-applied-claim-import-option.component';
import { ReportAppliedBooleanOptionComponent } from '../../../shared/components/report-applied-boolean-option/report-applied-boolean-option.component';

@Component({
    templateUrl: './icc-export-claims.component.html',
    imports: [ReportsComponent,
              NewReportOptionsTemplateDirective,
              FormsModule,
              ReactiveFormsModule,
              ReportClientOptionComponent,
              IccReportClaimImportOptionComponent,
              ReportBooleanOptionComponent,
              ReportDetailsTemplateDirective,
              ReportAppliedClientOptionComponent,
              IccReportAppliedClaimImportOptionComponent,
              ReportAppliedBooleanOptionComponent]
})
export class IccExportClaimsComponent {
  private formBuilder = inject(UntypedFormBuilder);

  reportsUrl = `${environment.captureApi.url}/icc/capture_reports`;

  filtersForm = this.formBuilder.group({
    clientId: [null, Validators.required],
    iccClaimImportId: [null, Validators.required],
  });

  outputOptionsForm = this.formBuilder.group({
    includeSourceColumns: [null],
  });
}
